var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.meterDevice)?_c('div',{staticClass:"meter-device-usage"},[_c('report-usages-list',{attrs:{"show-no-energy":"","meterDeviceId":_vm.meterDevice.id}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }